import _ from 'lodash'
import MarkdownIt from 'markdown-it'
const md = new MarkdownIt()
let htmls = null
import i18n from '../lang'

function inspection(sections) {
  const inspections = _.get(sections, 'inspections')
  if (!inspections) {
    return ''
  }
  const rows = _.map(inspections.items, (item, index) => `<tr><td>${index + 1}</td><td>${item.remark}</td><td>${item.result}</td></tr>`)

  return `<table>
    <tr><td colspan="3">Select <strong>${inspections.pieces}</strong> pieces from current factory production</td></tr>
    <tr><td colspan="3">Item inspected: ${inspections.item_inspected}</td></tr>
    <tr><td class="label">Sample Number</td><td class="label">Enter Defect Description for Any Defects Found</td><td class="label">Accept/Reject</td></tr>
    ${_.join(rows, '')}
  </table>`
}

function processes(sections) {
  const result = {}
  _.each(_.get(sections, 'processes.items'), process => {
    result[`process_${process.index}`] = `<table>
      <tr><td class="label" style="width: 50%;">Machines (Item & number)</td><td style="white-space: pre-line;">${process.machines}</td><tr>
      <tr><td class="label">Maximum Daily Output</td><td>${process.daily_output}</td><tr>
      <tr><td class="label">Number of Workers</td><td>${process.work_numbers}</td><tr>
      ${process.remark ? `<tr><td class="label">Remark</td><td>${process.remark}</td><tr>` : ''}
    </table>`
  })
  return result
}

function base_information(sections) {
  const info = _.get(sections, 'info')
  const table_html = i18n.locale == 'zh'?`<table>
  <tr><td class="label" style="width: 28%;">工厂名称</td><td>${info.factory_name}</td></tr>
  <tr><td class="label" >工厂地址</td><td>${info.factory_address}</td></tr><tr><td class="label">审核日期</td><td>${info.audit_date}</td></tr>
  <tr><td class="label">审核员</td><td>${info.auditor}</td></tr>
</table>`:
  `<table>
  <tr><td class="label" rowspan="2" style="width: 28%;">Factory Name</td><td>${info.factory_name}</td></tr>
  <tr><td>${info.factory_name_en}</td></tr>
  <tr><td class="label" rowspan="2">Factory Address</td><td>${info.factory_address}</td></tr>
  <tr><td>${info.factory_address_en}</td></tr><tr><td class="label">Audit Date</td><td>${info.audit_date}</td></tr>
  <tr><td class="label">Auditor</td><td>${info.auditor}</td></tr>
</table>`
  return `${table_html}
  <p>${info.summary ? md.render(info.summary) : ''}</p>`
}

function scene_information(sections, scenes) {
  const result = {}
  const buildings = _.flatten(_.map(_.get(sections, 'buildings.items'), building => {
    return _.map(building.floors, (floor, index) => {
      return {
        value: `${floor._key}`,
        label: `Building ${ building.name }# ${ floor.floor }F`,
      }
    })
  }), 1)
  const title_location = i18n.locale == 'zh'?'位置':'Location'
  const title_area = i18n.locale == 'zh'?'面积(㎡)':'Areas(㎡)'
  _.each(scenes, scene => {
    result[`scene_${scene.uid}`] = `<table>
      <tr><td class="label">${title_location}</td><td>${_.get(_.find(buildings, {value: scene.summary.building}), 'label', 'N/A')}</td></tr>
      <tr><td class="label">${title_area}</td><td>${scene.summary.area ? scene.summary.area : 'N/A'}</td></tr>
    </table>`
  })
  return result
}

function parseSections(sections, scenes) {
  return {
    inspection: inspection(sections),
    ...processes(sections),
    base_information: base_information(sections),
    ...scene_information(sections, scenes)
  }
}

export default {
  init(sections, scenes) {
    htmls = parseSections(sections, scenes)
  },
  template(template) {
    const result = template ? _.template(md.render(template))(htmls) : ''
    return result
  }
}